/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for CommentResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetCommentsResponse } from "../models";

@Injectable({ providedIn: "root" })
export class CommentResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getComments(entityType: Signal<any> | any, entityId: Signal<number> | number, resourceOptions: HttpResourceOptions<GetCommentsResponse, unknown> & { defaultValue: NoInfer<GetCommentsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCommentsResponse>;
    getComments(entityType: Signal<any> | any, entityId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCommentsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCommentsResponse | undefined>;
    getComments(entityType: Signal<any> | any, entityId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCommentsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCommentsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Comment/${typeof entityType === 'function' ? entityType() : entityType}/${typeof entityId === 'function' ? entityId() : entityId}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
